import { createAction } from 'redux-actions';
import { PapiDeviation } from '@wix/da-types-papi';

export type UpdateCoverDeviationPayload = {
  deviation: PapiDeviation;
  version?: number;
};
export const updateCoverDeviation = createAction<UpdateCoverDeviationPayload>(
  'UPDATE_COVER_DEVIATION'
);

export type UpdateCoverDeviationOffsetYPayload = {
  offsetY: number;
  version: number;
};
export const updateCoverDeviationOffsetY = createAction<
  UpdateCoverDeviationOffsetYPayload
>('UPDATE_COVER_DEVIATION_OFFSET_Y');

export const deleteCoverDeviation = createAction('DELETE_COVER_DEVIATION');
